import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, NotebookPen, MessageCircleHeart } from "lucide-react";

const READING_BG = "https://images.unsplash.com/photo-1581713872605-b9dfbc84eaa4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxjYWxtJTIwbW9ybmluZyUyMG1pc3QlMjBuYXR1cmV8ZW58MHx8fHwxNzgyNjMyMTM3fDA&ixlib=rb-4.1.0&q=85";

export default function DailyReading() {
  const navigate = useNavigate();
  const [reading, setReading] = useState(null);

  useEffect(() => { api.get("/reading/daily").then((r) => setReading(r.data)); }, []);
  if (!reading) return null;

  const today = new Date().toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" });

  return (
    <div className="relative min-h-screen">
      <img src={READING_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-10" />
      <div className="relative max-w-2xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <button data-testid="reading-back-button" onClick={() => navigate("/")} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-12">
          <ArrowLeft className="w-4 h-4" /> Home
        </button>

        <div className="animate-fade-up">
          <p className="label-overline mb-2">Daily Devotional · {today}</p>
          <h1 className="font-heading text-4xl sm:text-5xl tracking-tight leading-none" data-testid="reading-title">{reading.title}</h1>

          <blockquote className="font-scripture italic text-2xl sm:text-3xl leading-relaxed text-primary mt-10 border-l-2 border-primary/20 pl-6">
            "{reading.verse}"
            <footer className="font-body not-italic text-base text-muted-foreground mt-3">{reading.verse_ref}</footer>
          </blockquote>

          <div className="mt-10 space-y-5 text-lg leading-loose text-foreground/90">
            {reading.reflection.split("\n\n").map((p) => <p key={p.slice(0, 60)}>{p}</p>)}
          </div>

          <div className="bg-card border border-border rounded-md p-7 mt-10">
            <p className="label-overline mb-3">A Prayer</p>
            <p className="font-scripture italic text-xl leading-relaxed text-primary">{reading.prayer}</p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-12">
            <button data-testid="reading-journal-button" onClick={() => navigate("/journal")}
              className="flex items-center justify-center gap-2 bg-primary text-primary-foreground rounded-sm px-6 py-3.5 hover:bg-primary/90 transition-colors">
              <NotebookPen className="w-4 h-4" /> Journal this reflection
            </button>
            <button data-testid="reading-guide-button" onClick={() => navigate("/guide")}
              className="flex items-center justify-center gap-2 border border-border rounded-sm px-6 py-3.5 hover:bg-muted transition-colors">
              <MessageCircleHeart className="w-4 h-4 text-accent" /> Talk to the Guide
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
